import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { TEST_IDS } from "@/constants/testIds";
import { GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/library", { replace: true }); }, [user, navigate]);

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center paper-bg px-6 py-16">
      <div className="bg-[#EAE4D3] border-2 border-[#1F2924] shadow-tactile p-10 max-w-md w-full">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#D35230] mb-2">Membership</div>
        <h1 className="font-serif-display text-5xl mb-3 leading-none">Join the broadcast.</h1>
        <p className="text-[#1F2924]/80 mb-8 leading-relaxed">
          Sign in to save your favourite stations, build playlists across the globe, and pick up
          where you left off.
        </p>

        <button
          data-testid={TEST_IDS.auth.googleLogin}
          onClick={login}
          className="w-full py-3.5 bg-[#1F2924] text-[#F4F1EA] border-2 border-[#1F2924] hover:bg-[#D35230] hover:border-[#D35230] font-mono text-xs uppercase tracking-[0.25em] flex items-center justify-center gap-3"
        >
          <GoogleLogo size={18} weight="bold" /> Continue with Google
        </button>

        <div className="mt-8 pt-6 border-t border-[#1F2924]/20">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4A5A50]">
            Secure · One-tap · No passwords stored
          </div>
        </div>
      </div>
    </div>
  );
}
